/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientContent } from '../../models/client-content';

export interface ApiMasterClientContentGetByIdGet$Params {
  id?: string;
}

export function apiMasterClientContentGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterClientContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterClientContentGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientContent>;
    })
  );
}

apiMasterClientContentGetByIdGet.PATH = '/api/Master/ClientContent/GetById';
